module.exports = __webpack_public_path__ + "static/img/5.4348b7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/5.png
// module id = IP2l
// module chunks = 0